import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AlterarKmModule } from '@modules/alterar-km/alterar-km.module';
import { AtendimentosModule } from '@modules/atendimentos/atendimentos.module';
import { AuthModule } from '@modules/auth/auth.module';
import { CondutoresModule } from '@modules/condutores/condutores.module';
import { ConfiguracoesModule } from '@modules/configuracoes/configuracoes.module';
import { DashboardModule } from '@modules/dashboard/dashboard.module';
import { FaturamentoModule } from '@modules/faturamento/faturamento.module';
import { FrotaContratadaModule } from '@modules/frota-contratada/frota-contratada.module';
import { MultasModule } from '@modules/multas/multas.module';
import { NotificacaoModule } from '@modules/notificacoes/notificacoes.module';
import { PneusModule } from '@modules/pneus/pneus.module';
import { ServicosExecutadosModule } from '@modules/servicos-executados/servicos-executados.module';
import { MedicoesModule } from './medicoes/medicoes.module';
import { InspecoesModule } from '@modules/inspecoes/inspecoes.module';

@NgModule({
  declarations: [],
  imports: [
    AtendimentosModule,
    AuthModule,
    CommonModule,
    CondutoresModule,
    DashboardModule,
    FrotaContratadaModule,
    AtendimentosModule,
    AlterarKmModule,
    FaturamentoModule,
    MultasModule,
    ServicosExecutadosModule,
    PneusModule,
    NotificacaoModule,
    ConfiguracoesModule,
    MedicoesModule,
    InspecoesModule,
  ],
  providers: [],
})
export class ModulesModule {}
